module.exports = __webpack_public_path__ + "img/nav-right-expand-search-ford.8c1ddc30.png";